import { Lock } from 'lucide-react'

export const PaymentTrust = () => (
  <div className="flex flex-col items-center gap-2.5 pt-1">
    <p className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <Lock className="h-3.5 w-3.5" />
      Secure checkout powered by Stripe
    </p>
    <div className="flex items-center gap-1.5" aria-hidden="true">
      <VisaMark />
      <MastercardMark />
      <AmexMark />
      <DiscoverMark />
    </div>
  </div>
)

const Chip = ({ children }: { children: React.ReactNode }) => (
  <span className="inline-flex h-5 w-8 items-center justify-center overflow-hidden rounded border border-border bg-white">
    <svg viewBox="0 0 40 24" className="h-full w-full" role="presentation">
      {children}
    </svg>
  </span>
)

const VisaMark = () => (
  <Chip>
    <text
      x="20"
      y="16"
      textAnchor="middle"
      fontSize="11"
      fontWeight="700"
      fontStyle="italic"
      fontFamily="Arial, sans-serif"
      fill="#1A1F71"
    >
      VISA
    </text>
  </Chip>
)

const MastercardMark = () => (
  <Chip>
    <circle cx="16" cy="12" r="7" fill="#EB001B" />
    <circle cx="24" cy="12" r="7" fill="#F79E1B" />
    <path d="M20 6.5a7 7 0 0 1 0 11 7 7 0 0 1 0-11z" fill="#FF5F00" />
  </Chip>
)

const AmexMark = () => (
  <Chip>
    <rect width="40" height="24" fill="#1F72CF" />
    <text
      x="20"
      y="15"
      textAnchor="middle"
      fontSize="7"
      fontWeight="700"
      fontFamily="Arial, sans-serif"
      fill="#fff"
    >
      AMEX
    </text>
  </Chip>
)

const DiscoverMark = () => (
  <Chip>
    <text
      x="4"
      y="16"
      fontSize="7"
      fontWeight="700"
      fontFamily="Arial, sans-serif"
      fill="#1A1F71"
    >
      DISC
    </text>
    <circle cx="33" cy="12" r="5" fill="#F76E11" />
  </Chip>
)
